import React from 'react';
import { connect } from 'react-redux';
import { LabeledCheckbox } from 'components/shared/checkbox';
import Table from '../table';
import {
  bulkActionsAddAll,
  bulkActionsRemoveAll,
} from '../../../actions/shared/index/bulk_core';
import {
  selectedItemsCountSelector,
  itemsIndexesSelector,
  isLoading,
  shouldDisableContentCheckboxes,
} from '../../../selectors';

const SelectAllCell = props => (
  <Table.BodyCell size="xs" style={props.style}>
    <LabeledCheckbox
      disabled={props.isLoading || props.disabled}
      onChange={() => props.toggleItems(props.indexes, props.indeterminate)}
      checked={props.checked}
      indeterminate={props.indeterminate}
      className="u-margin-0"
      ariaLabel={t('common.select_all')}
    />
  </Table.BodyCell>
);

const isSelectable = item => {
  return (!item.type || item.type !== 'practice/container') && item.urls.edit;
};
const filterOutContainers = data => data.filter(isSelectable);

const mapStateToProps = state => ({
  checked: !!selectedItemsCountSelector(state),
  indexes: itemsIndexesSelector(state, isSelectable),
  indeterminate:
    filterOutContainers(state.data.content).length !==
    selectedItemsCountSelector(state),
  isLoading: isLoading(state),
  disabled: shouldDisableContentCheckboxes(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggleItems(indexes, indeterminate) {
    if (indeterminate) dispatch(bulkActionsAddAll(indexes));
    else dispatch(bulkActionsRemoveAll(indexes));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectAllCell);
